export default {
    props: {
        editableConnectionTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.connectionTemplate'
        }, 
        editableDrag: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.drag'
        }, 
        editableDragSnap: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.drag.snap'
        }, 
        editableDragSnapSize: {
            type: Number,
            default: undefined,
            kComposite: 'editable.drag.snap.size'
        }, 
        editableRemove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.remove'
        }, 
        editableResize: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.resize'
        }, 
        editableResizeHandlesFill: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.fill'
        }, 
        editableResizeHandlesFillColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.fill.color'
        }, 
        editableResizeHandlesFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.fill.opacity'
        }, 
        editableResizeHandlesHeight: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.height'
        }, 
        editableResizeHandlesHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.fill'
        }, 
        editableResizeHandlesHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.fill.color'
        }, 
        editableResizeHandlesHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.fill.opacity'
        }, 
        editableResizeHandlesHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.stroke.color'
        }, 
        editableResizeHandlesHoverStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.stroke.dashType'
        }, 
        editableResizeHandlesHoverStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.hover.stroke.width'
        }, 
        editableResizeHandlesStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.stroke.color'
        }, 
        editableResizeHandlesStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'editable.resize.handles.stroke.dashType'
        }, 
        editableResizeHandlesStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.stroke.width'
        }, 
        editableResizeHandlesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.resize.handles.width'
        }, 
        editableRotate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.rotate'
        }, 
        editableRotateFillColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.rotate.fill.color'
        }, 
        editableRotateFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'editable.rotate.fill.opacity'
        }, 
        editableRotateStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'editable.rotate.stroke.color'
        }, 
        editableRotateStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'editable.rotate.stroke.width'
        }, 
        editableShapeTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.shapeTemplate'
        }, 
        editableTools: {
            type: Array,
            default: undefined,
            kComposite: 'editable.tools'
        }    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/Editable.js